import { Button, Hairline, Input, Label, Radio } from "@components";
import { CurrencyInput } from "@components/CurrencyInput";
import { If } from "@components/control-statements";
import { VariableSchema } from "@containers/oraculo/VariableSchema";
import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";
import { useState } from "react";
import { TimeForm } from "./TimeForm";

export default ({
	node,
	disableTimeRange = false,
	input_configs = {},
	onSave,
	onRemove,
}) => {

	const [operand, setOperand] = useState(node.operand || "gte");
	const [value, setValue] = useState(
		formatValue(node.operand, node.value || input_configs?.min || 0)
	);

	const [range, setRange] = useState(node.range || {});

	const getFreshNode = () => {
		return { ...node, operand, value, range };
	};

	const changeOperand = (_operand) => {
		if (_operand == "bt") {
			setValue([input_configs?.min || null, input_configs?.max || null]);
		}
		setOperand(_operand);
	};

	const validate = () => {
		const { min, max, type } = input_configs || {};
		if (!operand || value === null || value === undefined || value === "") {
			return false;
		}

		if (["currency", "number"].includes(type)) {
			if (min !== undefined && +value < min) {
				return false;
			}

			if (max !== undefined && +value > max) {
				return false;
			}
		}

		return true;
	};

	const is_number = ["currency", "number"].includes(input_configs?.type);
	const InputComponent = is_number ? CurrencyInput : Input;	

	return (
		<>
			<div className={styles.scrollContainer}>
				<div className={styles.card}>
					<Label>Defina o uso desta variável:</Label>
					<Hairline solid className="mt-5 mb-20" />
					<Radio
						family="variableType"
						className="mb-10"
						value="eq"
						checked={operand}
						onChange={() => changeOperand("eq")}
					>
						Igual a
					</Radio>
					<Radio
						family="variableType"
						className="mb-10"
						value="neq"
						checked={operand}
						onChange={() => changeOperand("neq")}
					>
						Diferente de
					</Radio>
					<Radio
						family="variableType"
						className="mb-10"
						value="gte"
						checked={operand}
						onChange={() => changeOperand("gte")}
					>
						No mínimo
					</Radio>
					<Radio
						family="variableType"
						className="mb-10"
						value="lte"
						checked={operand}
						onChange={() => changeOperand("lte")}
					>
						No máximo
					</Radio>
					<Radio
						family="variableType"
						value="bt"
						checked={operand}
						onChange={() => changeOperand("bt")}
					>
						Intervalo (de / até)
					</Radio>
				</div>

				<div className={styles.card}>
					<Label>Determine o valor de comparação:</Label>
					<Hairline solid className="mt-10 mb-20" />
					<If cond={operand !== "bt"}>
						<InputComponent
							{...(input_configs || {})}
							value={formatValue(operand, value)}
							onChange={(e, m, v) => {
								const value = is_number ? v : e === null ? "" : e.target.value;
								setValue(value);
							}}
							className="mb-0"
						/>
					</If>
					<If cond={operand == "bt"}>
						<InputComponent
							{...(input_configs || {})}
							value={formatValue(operand, value)[0]}
							placeholder="De"
							onChange={(e, m, _val) => {
								const v = formatValue(operand, value);
								const _value = is_number ? _val : e === null ? "" : e?.target?.value;
								setValue([_value, v[1]]);
							}}
							className="mb-10"
						/>
						<InputComponent
							{...(input_configs || {})}
							value={formatValue(operand, value)[1]}
							placeholder="Até"
							onChange={(e, m, _val) => {
								const v = formatValue(operand, value);
								const _value = is_number ? _val : e === null ? "" : e?.target?.value;
								setValue([v[0], _value]);
							}}
							className="mb-0"
						/>
					</If>
				</div>
				<If cond={!disableTimeRange}>
					<div className={styles.card}>
						<Label>Faixa de tempo:</Label>
						<Hairline solid className="mt-10 mb-20" />
						<TimeForm range={range} onChange={(r) => setRange(r)} />
					</div>
				</If>
			</div>

			<div className={styles.footer}>
				<Button
					className="w-100"
					onClick={() => onSave(getFreshNode())}
					disabled={!validate() || !VariableSchema.validateRange(range)}
					design="primary"
				>
					Aplicar
				</Button>
				<Button
					design="underline"
					className="mt-20 mb-10"
					onClick={() => onRemove(getFreshNode())}
				>
					Remover comparação
				</Button>
			</div>
		</>
	);
};

const formatValue = (operand, value) => {
	if (operand == "bt") {
		return Array.isArray(value) ? value : [null, null];
	}
	return value;
};
